import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useJoinTournament(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation({
    mutationFn: async (payload: {tournamentId: number; playerId: number}) => {
      const headers = {
        'x-api-key': '2d30f638-8922-4d8a-bb77-e25ad4af0aed',
        'Content-Type': 'application/json',
      };
      const response = await TournamentRestClient.post(
        `/players/join-tournament/${payload.tournamentId}`,
        {playerId: payload.playerId},
        {headers},
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) {
        handleOnSuccess(data);
      }
    },
    onError: error => {
      if (handleOnError) {
        handleOnError(error);
      }
    },
  });
}
